import { Navigate, generatePath } from "react-router";

import { type LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { HotelSettingsHotelInfoI18nPresenter } from "./presenter";
import { useHotelInfoI18nQuery } from "../../model/repository/query/use-hotel-info-i18n-query";

type Props = {
	hotelID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const HotelSettingsHotelInfoI18nContainer = ({ hotelID, activeLangCode, navigator }: Props) => {
	const { data } = useHotelInfoI18nQuery({
		hotelID,
		langCode: activeLangCode,
	});

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <HotelSettingsHotelInfoI18nPresenter activeLangCode={activeLangCode} navigator={navigator} data={data} />;
};

HotelSettingsHotelInfoI18nContainer.displayName = "HotelSettingsHotelInfoI18nContainer";
